import React, { FC } from 'react';

import { Control, Controller } from 'react-hook-form';

import { Autocomplete, Grid, TextField } from '@mui/material';

import { PromoLoyaltyMetaConfig } from '~/services/PromoService';

import Spinner from '../Common/Spinner';

interface LoyaltyBonusApplyMethodSelectorProps {
  promoLoyaltyMetaConfig: PromoLoyaltyMetaConfig | null;
  isPromoMetaLoading: boolean;
  control: Control<any>;
  isErroring?: boolean;
}

const LoyaltyBonusApplyMethodSelector: FC<LoyaltyBonusApplyMethodSelectorProps> = ({
  promoLoyaltyMetaConfig,
  isPromoMetaLoading,
  control,
  isErroring = false,
}) => {
  if (isPromoMetaLoading) {
    return <Spinner />;
  }

  const options = promoLoyaltyMetaConfig?.loyaltyBonusFilterMethods ?? [];

  return (
    <Controller
      key="loyalty_bonus_apply_method"
      name="loyalty_bonus_apply_method"
      control={control}
      render={({ field }) => (
        <Grid item xs={2}>
          <Autocomplete
            {...field}
            value={options.find((option) => option.key === field.value) || null}
            options={options}
            getOptionLabel={(option) => option.name || option.key}
            isOptionEqualToValue={(option, value) => option.key === value?.key}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="Loyalty Bonus Apply Method" error={isErroring} />
            )}
            onChange={(e: unknown, newValue: any) => {
              field.onChange(newValue?.key || null);
            }}
          />
        </Grid>
      )}
    />
  );
};

export default LoyaltyBonusApplyMethodSelector;
